/* Norvena magnesium gummies product-template kit (resovive-* content sections).
 * Loaded once from resovive-01. Wires:
 *   - every content CTA (a[href="#resovive-offer"]) -> smooth scroll to the buy-box offer
 *   - carousels / swipe-to-compare tracks -> drag + wheel + arrows + scroll-snap
 *   - FAQ <details> accordions (native, with a smooth max-height reveal)
 *   - re-inits on shopify:section:load (theme editor re-renders a section on open)
 */
(function(){
  'use strict';

  function offerEl(){
    return document.getElementById('resovive-offer')
        || document.querySelector('form[action*="/cart/add"] [name="add"], product-form button[name="add"], button[name="add"]')
        || document.querySelector('[id*="__main"], #MainContent');
  }
  function scrollOffer(){
    var el=offerEl(); if(!el) return;
    var to=Math.max(0, window.scrollY + el.getBoundingClientRect().top - 24);
    try{ window.scrollTo({top:to,behavior:'smooth'}); }
    catch(e){ window.scrollTo(0,to); }
  }

  /* All CTAs inside the cloned content go to the offer (same as the competitor). */
  function wireCtas(root){
    var links=(root||document).querySelectorAll('.rv a[href="#resovive-offer"], .rv a[href^="#shopify-section"]');
    [].slice.call(links).forEach(function(a){
      if(a.__rv) return; a.__rv=1;
      a.addEventListener('click',function(e){ e.preventDefault(); scrollOffer(); });
    });
  }

  /* Horizontal carousels / comparison tables: make the track draggable, wheel- and
   * arrow-scrollable with scroll-snap. Works whether or not the theme's Splide inits. */
  /* turn one element into a drag/wheel/touch horizontal scroller */
  function makeScroller(t){
    if(t.__rv) return; t.__rv=1;
    t.style.overflowX = 'auto';
    t.style.scrollSnapType = t.style.scrollSnapType || 'x proximity';
    t.style.webkitOverflowScrolling='touch';
    t.style.scrollBehavior='smooth';
    var down=false, sx=0, sl=0, moved=false;
    t.addEventListener('pointerdown',function(e){
      if(e.pointerType==='mouse' && e.button!==0) return;
      down=true; moved=false; sx=e.clientX; sl=t.scrollLeft;
      t.classList.add('rv-dragging');
    });
    t.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true;
      t.scrollLeft = sl - dx;
    });
    function up(){ down=false; t.classList.remove('rv-dragging'); }
    t.addEventListener('pointerup',up);
    t.addEventListener('pointerleave',up);
    t.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
    t.addEventListener('wheel',function(e){
      if(t.scrollWidth<=t.clientWidth) return;
      if(Math.abs(e.deltaY)>Math.abs(e.deltaX)){ t.scrollLeft+=e.deltaY; e.preventDefault(); }
    },{passive:false});
  }

  /* Horizontal carousels / comparison tables. Works whether or not the theme's own
   * carousel JS inits: Splide tracks AND this theme's transform-based carousels
   * (.carousel-track / .testimonials-track, driven on the live site by scripts we
   * don't ship) are overridden into real scroll-snap flex rows. */
  function wireScrollers(root){
    root=root||document;
    /* native scroll-snap tracks */
    [].slice.call(root.querySelectorAll('.rv .splide__track, .rv .scroll, .rv [data-vx-scroll]'))
      .forEach(makeScroller);
    /* transform-based carousels -> neutralise the dead transform, scroll the clipping box */
    [].slice.call(root.querySelectorAll('.rv .carousel-track, .rv .testimonials-track'))
      .forEach(function(track){
        if(track.__rvtr) return; track.__rvtr=1;
        track.style.setProperty('transform','none','important');
        track.style.setProperty('transition','none','important');
        var box=track.parentElement, scroller=track;
        if(box){
          var ox=getComputedStyle(box).overflowX;
          if(ox==='hidden'||ox==='clip'){ scroller=box; }
        }
        makeScroller(scroller);
        track.__rvscroller=scroller;
      });
    /* arrows: Splide + this theme's .nav-button.prev/.next drive their nearest track */
    [].slice.call(root.querySelectorAll('.rv .splide__arrow, .rv .nav-button'))
      .forEach(function(btn){
        if(btn.__rv) return; btn.__rv=1;
        btn.addEventListener('click',function(e){
          var sp=btn.closest('.splide, .steps-container, .testimonials-carousel, section');
          if(!sp) return;
          var track=sp.querySelector('.splide__track, .carousel-track, .testimonials-track, .scroll');
          if(!track) return;
          var scroller=track.__rvscroller||track;
          var prev=/prev/.test(btn.className);
          var card=scroller.querySelector('.carousel-slide, .testimonial-card, li, .splide__slide, :scope > *');
          var step=card?Math.max(220,card.getBoundingClientRect().width+16):Math.max(240,scroller.clientWidth*0.85);
          e.preventDefault();
          try{ scroller.scrollTo({left:scroller.scrollLeft+(prev?-step:step),behavior:'smooth'}); }
          catch(_){ scroller.scrollLeft+=prev?-step:step; }
        });
      });
  }

  /* FAQ <details>: native toggle works; add a smooth max-height reveal and make the
   * whole summary row the hit target. */
  function wireDetails(root){
    var ds=(root||document).querySelectorAll('.rv details');
    [].slice.call(ds).forEach(function(d){
      if(d.__rv) return; d.__rv=1;
      var body=d.querySelector('summary ~ *') ||
               (function(){ var s=d.querySelector('summary'); return s?s.nextElementSibling:null; })();
      if(!body) return;
      function sync(){
        if(d.open){ body.style.maxHeight=body.scrollHeight+'px'; body.style.opacity='1'; }
        else { body.style.maxHeight='0px'; body.style.opacity='0'; }
      }
      body.style.overflow='hidden';
      body.style.transition='max-height .26s ease, opacity .26s ease';
      sync();
      d.addEventListener('toggle',sync);
      window.addEventListener('resize',function(){ if(d.open) body.style.maxHeight=body.scrollHeight+'px'; });
    });
  }

  /* This theme's custom FAQ accordion (.store-faq-item / -question / -answer): the
   * reveal is pure CSS on .store-faq-item.active, but the toggling script isn't shipped.
   * Wire the click so questions open/close (and close siblings for a clean accordion). */
  function wireFaq(root){
    var qs=(root||document).querySelectorAll('.rv .store-faq-question');
    [].slice.call(qs).forEach(function(q){
      if(q.__rv) return; q.__rv=1;
      q.addEventListener('click',function(){
        var item=q.closest('.store-faq-item'); if(!item) return;
        var wasOpen=item.classList.contains('active');
        var group=item.closest('.store-faq, .store-faq-items-container, section')||document;
        [].slice.call(group.querySelectorAll('.store-faq-item.active')).forEach(function(o){
          if(o!==item) o.classList.remove('active');
        });
        item.classList.toggle('active', !wasOpen);
      });
    });
  }

  function init(root){ wireCtas(root); wireScrollers(root); wireDetails(root); wireFaq(root); }

  if(document.readyState!=='loading') init();
  document.addEventListener('DOMContentLoaded',function(){ init(); });
  document.addEventListener('shopify:section:load',function(e){ init(e.target||document); });
  setTimeout(init,600); setTimeout(init,1800);
})();

/* QA: collapse duplicate listicle header variants per section */
(function(){function dedupe(){document.querySelectorAll('[id^="shopify-section"]').forEach(function(sec){var seen={};sec.querySelectorAll("h1,h2").forEach(function(h){if(h.offsetParent===null)return;var t=h.textContent.replace(/\s+/g," ").trim().toLowerCase();if(t.length>15){if(seen[t]){h.style.display="none";var lh=h.closest(".listicle-header");if(lh)lh.style.display="none";}else{seen[t]=1;}}});});}if(document.readyState!=="loading")dedupe();else document.addEventListener("DOMContentLoaded",dedupe);document.addEventListener("shopify:section:load",dedupe);setTimeout(dedupe,800);})();

/* QA: reward band -> rows via textContent split (safe, idempotent) */
(function(){function rows(){document.querySelectorAll('.lumin-qty-bottom').forEach(function(b){if(b.querySelector('.rv-rwd'))return;var txt=(b.textContent||'').trim();if(txt.indexOf('·')<0)return;var parts=txt.split('·').map(function(p){return p.trim();}).filter(Boolean);if(parts.length<2)return;while(b.firstChild)b.removeChild(b.firstChild);parts.forEach(function(p){var d=document.createElement('div');d.className='rv-rwd';d.textContent=p;b.appendChild(d);});});}if(document.readyState!=='loading')rows();else document.addEventListener('DOMContentLoaded',rows);document.addEventListener('shopify:section:load',rows);setTimeout(rows,700);setTimeout(rows,1600);})();

/* QA FIX (2026-10-04): clone stripped inline <script> from content_tabs sections -> tab/category buttons dead.
   Wire any content-tabs section + reveal roadmap fade-out items. Contract: .tab-content..{display:none} / .active{display:block}. */
(function(){
  function wireTabs(){
    document.querySelectorAll('[class*="content-tabs-template--"]').forEach(function(sec){
      var btns=sec.querySelectorAll('[data-tab]');
      if(!btns.length)return;
      btns.forEach(function(b){
        if(b.dataset.rvtab)return; b.dataset.rvtab='1';
        b.addEventListener('click',function(ev){
          ev.preventDefault();
          var id=b.getAttribute('data-tab');
          btns.forEach(function(x){x.classList.remove('active');});
          b.classList.add('active');
          sec.querySelectorAll('[class*="tab-content-template--"]').forEach(function(p){p.classList.remove('active');});
          var panel=document.getElementById(id);
          if(panel)panel.classList.add('active');
        });
      });
    });
  }
  function revealFade(){
    document.querySelectorAll('.fade-out').forEach(function(el){el.style.opacity='1';el.style.transform='none';});
  }
  function run(){try{wireTabs();}catch(e){} try{revealFade();}catch(e){}}
  if(document.readyState!=='loading')run(); else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
  setTimeout(run,800);
})();
